export default "/images/vendor/flag-icons/flags/4x3/iq.svg?828e7dfbad11c0f6cd26bcbf74a72b99";